import { GlobalStore } from "store/global/GlobalStore";
import { useIsDesktop } from "./useDeviceType";

interface useDeviceBasedTextStylesProps {
  shouldScale: boolean;
}

export const useDeviceBasedTextStyles = ({ shouldScale }: useDeviceBasedTextStylesProps) => {
  const isDesktop = useIsDesktop();
  let deviceTypeSelector: "Desktop" | "Mobile" = "Desktop" as const;
  if (shouldScale) {
    deviceTypeSelector = isDesktop ? "Desktop" : "Mobile";
  }
  const theme = GlobalStore.useState(s => s.theme);
  return theme[deviceTypeSelector];
};
